import { protection_plans_slug, s_and_p_plan_slug } from "../utils/slugs";

export const apiEndPoints = {
  tools: "/api/tool",
  home: "/api/home?populate[hero_sec][populate][content]=true&populate[hero_sec][populate][actions]=true&populate[hero_sec][populate][banner][populate][img]=true&populate[hero_sec][populate][banner][populate][arabic_img]=true&populate[banner_sec][populate][content]=true&populate[banner_sec][populate][action]=true&populate[banner_sec][populate][banner][populate][img]=true&populate[plan_sec][populate][content]=true&populate[plan_sec][populate][actions]=true&populate[plan_sec][populate][steps][populate][icon]=true&populate[testimonial_sec][populate][testimonials][populate][user_img]=true&populate[testimonial_sec][populate][content]=true&populate[bog_sec][populate][content]=true&populate[bog_sec][populate][action]=true&populate[seo_meta][populate][og_image]=true&populate[seo_meta][populate][twitter_image]=true",
  home_plans: `/api/plan-types?populate[plans][populate][banner][populate][img]=true&populate[plans][populate][slider_titles]=true&populate[banner][populate][arabic_img]=true&filters[slug][$in][0]=${s_and_p_plan_slug}&filters[slug][$in][1]=${protection_plans_slug}`,
  //getHeaderRoutes
  plansHeaderRoutes:
    "/api/plan-types?populate[content]=true&populate[plans][populate]=content&populate[header_menu_icon][populate]=img&sort=order",
  //Plan Type Config
  planTypeConfig:
    "/api/plan-type-config?populate[plan_step_sec][populate]=content,actions,steps.icon&populate[faq_sec_info]=true&populate[faqs][populate]=question,answer&populate[hero_action]=true&populate[plan_actions]=true&populate[faq_sub_sec_question]=true&populate[faq_actions]=true&populate[bottom_banner][populate]=banner.img,content,action",
  //planType With Plans
  planTypeWithPlans:
    "/api/plan-types?populate[plans][populate][banner][populate][img]=true&populate[plans][populate][slider_titles]=true&populate[banner][populate][arabic_img]=true&filters[slug][$in][0]=savings-and-protection-plans&filters[slug][$in][1]=protection-plans",
  //planDetails
  planDetail:
    "/api/plans?filters[slug][$eq]=" +
    "&populate[banner][populate][img]=true" +
    "&populate[banner][populate][arabic_img]=true" +
    "&populate[key_feat][populate][icon]=true" +
    "&populate[content]=true" +
    "&populate[faqs][populate][question]=true" +
    "&populate[faqs][populate][answer]=true" +
    "&populate[plan_step_sec][populate][actions]=true" +
    "&populate[plan_step_sec][populate][steps][populate][icon]=true" +
    "&populate[plan_step_sec][populate][content]=true",
  // planDetailsConfig
  planDetailConfig: "/api/plan-config?populate=*",
  getArticlePgeStaticData:
    "/api/learning-center?" +
    "populate[latest_article]=true" +
    "&populate[cta][populate][banner][populate][img]=true" +
    "&populate[cta][populate][content]=true" +
    "&populate[cta][populate][actions]=true" +
    "&populate[blog_category_detail_btn]=true" +
    "&populate[services_section][populate][content]=true" +
    "&populate[services_section][populate][services][populate][icon]=true" +
    "&populate[services_section][populate][actions]=true",
  getLearningCenterHomePageData:
    "/api/learning-center?" +
    // hero
    "populate[hero][populate][banner][populate][img]=true" +
    "&populate[hero][populate][banner][populate][arabic_img]=true" +
    "&populate[hero][populate][content]=true" +
    "&populate[hero][populate][actions]=true" +
    // services section
    "&populate[services_section][populate][content]=true" +
    "&populate[services_section][populate][services][populate][icon]=true" +
    "&populate[services_section][populate][actions]=true" +
    // latest article
    "&populate[latest_article]=true" +
    // CTA
    "&populate[cta][populate][banner][populate][img]=true" +
    "&populate[cta][populate][content]=true" +
    "&populate[cta][populate][actions]=true" +
    // misc
    "&populate[breadcrumb]=true" +
    "&populate[blog_category_detail_btn]=true" +
    "&populate[seo_meta][populate][og_image]=true" +
    "&populate[seo_meta][populate][twitter_image]=true",
  getLatestArticles: ({ category, count }) =>
    `/api/learning-articles?sort[publish_date]=desc` +
    `&populate[blog_image][populate][img]=true` +
    `&populate[tags]=true` +
    `&populate[categories]=true` +
    `&populate[authors][populate][avatar][populate][img]=true` +
    `&populate[content_section][populate][section_image][populate][img]=true` +
    (count ? `&pagination[limit]=${count}` : "") +
    (category
      ? `&filters[categories][slug][$eq]=${encodeURIComponent(category)}`
      : ""),

  getSingleArticle: (slug) =>
    `/api/learning-articles?filters[slug][$eq]=${encodeURIComponent(slug)}` +
    `&sort[publish_date]=desc` +
    `&populate[blog_image][populate][img]=true` +
    `&populate[tags]=true` +
    `&populate[categories]=true` +
    `&populate[content_section][populate][section_image][populate][img]=true` +
    `&populate[authors][populate][avatar][populate][img]=true` +
    `&populate[seo_meta][populate][og_image]=true` +
    `&populate[seo_meta][populate][twitter_image]=true`,
  getLearningCenterCategoryStaticData: (category, count) =>
    `/api/learning-article-categories?` +
    // SEO meta + images
    `populate[seo_meta][populate][og_image]=true` +
    `&populate[seo_meta][populate][twitter_image]=true` +
    // Articles + nested stuff
    `&populate[learning_articles][populate][blog_image][populate][img]=true` +
    `&populate[learning_articles][populate][content_section]=true` +
    `&populate[learning_articles][populate][tag]=true` +
    `&populate[learning_articles][populate][authors][populate][avatar][populate][img]=true` +
    // Filters & pagination
    (category
      ? `&filters[slug][$eq]=${encodeURIComponent(category)}`
      : "") +
    (count ? `&pagination[limit]=${count}` : ""),

  getSocialLinks: "/api/utils?populate[0]=social_icon.social_img",
  pageNotFound: "",
  planTypesHeader: "",
  parentMenusHeaderAndFooter:
    "/api/parent-menus?populate[label]=true&populate[menu_groups][populate][menu_group][populate][icon][populate][img]=true&populate[menu_groups][populate][menu_group][populate][menu][populate][icon]=true&sort=order",

  makeAclaim:
    "/api/make-a-claim?populate[hero][populate][title]=true&populate[hero][populate][subtitle]=true&populate[hero][populate][description]=true&populate[hero][populate][callus]=true&populate[hero][populate][mobile]=true&populate[hero][populate][email]=true&populate[hero][populate][emailadd]=true&populate[hero][populate][image][populate][img]=true&populate[faq][populate][qna]=true&populate[faq][populate][faq_heading]=true&populate[faq][populate][button]=true&populate[faq][populate][button_title]=true&populate[seo_meta][populate][og_image]=true&populate[seo_meta][populate][twitter_image]=true",

  speakToAdvisor: "",
  childCalculator:
    "/api/child-edu-goal?"
    + "populate[seo_meta][populate][og_image]=true"
    + "&populate[seo_meta][populate][twitter_image]=true"
    + "&populate[headings]=true"
    + "&populate[name_input_label]=true"
    + "&populate[email_input_label]=true"
    + "&populate[mobile_input_label]=true"
    + "&populate[university_menu]=true"
    + "&populate[university_in_mind_input_label]=true"
    + "&populate[inflation_menu]=true"
    + "&populate[action_btn]=true"
    + "&populate[result_action_btns]=true"
    + "&populate[result_disclaimer_text]=true"
    + "&populate[plan_term_input_label]=true"
    + "&populate[inflation_input_label]=true"
    + "&populate[select_university_input_label]=true"
    + "&populate[plan_term_menu]=true"
    + "&populate[banner][populate][img]=true",
  coverageCalculator:
    "/api/coverage-calculator?"
    + "populate[seo_meta][populate][og_image]=true"
    + "&populate[seo_meta][populate][twitter_image]=true"
    + "&populate[headings]=true"
    + "&populate[name_input_label]=true"
    + "&populate[email_input_label]=true"
    + "&populate[mobile_input_label]=true"
    + "&populate[d_o_b_input_label]=true"
    + "&populate[cpr_label]=true"
    + "&populate[currency_label]=true"
    + "&populate[annual_income_label]=true"
    + "&populate[no_of_years_label]=true"
    + "&populate[currency_menu]=true"
    + "&populate[action_btn]=true"
    + "&populate[result_action_btns]=true"
    + "&populate[result_disclaimer_text]=true"
    + "&populate[banner][populate][img]=true"
};
